import { createFileRoute } from "@tanstack/react-router";

import { RouteComponent } from "src/components/CoachLibrarySharedProgramRouteComponent";

export const Route = createFileRoute(
  "/_auth/_coach/library/programs/$programId/shared",
)({
  component: RoutePage,
  ssr: true,
  staticData: {
    getBreadcrumb({ params }) {
      return {
        href: `/library/programs/${params.programId}/shared`,
        label: "Shared",
      };
    },
  },
});

function RoutePage() {
  return <RouteComponent />;
}
